export default "__VITE_ASSET__B1Oza_GD__"